/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';

import { VersionCheckService } from './shared/services/version-check.service';
import { environment } from '../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { NbIcon, NbIcons, NbMediaBreakpointsService, NbThemeService } from '@nebular/theme';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NbIconLibraries } from '@nebular/theme';
import umamiIconMap from './shared/constants/umamiIconMap';

@Component({
    selector: 'ngx-app',
    template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {
    private destroy$: Subject<void> = new Subject<void>();
    private isViewportBiggerOrEqualToMd$: Subject<void> = new Subject<void>();

    constructor(
        public matDialog: MatDialog,
        private analytics: AnalyticsService,
        private versionCheckService: VersionCheckService,
        private breakpointService: NbMediaBreakpointsService,
        private themeService: NbThemeService,
        private iconLibraries: NbIconLibraries
    ) {
        this.iconLibraries.registerSvgPack('custom-icons', {
            completed: '<img src="/assets/images/checkmark_icon.svg">',
            taskFallback: '<img src="/assets/images/task_icon.svg">',
            businessName: '<img src="/assets/images/business_name_icon.svg">',
            enablePayments: '<img src="/assets/images/payments_icon.svg">',
            enableWithdrawals: '<img src="/assets/images/withdrawals_icon.svg">',
            uploadImage: '<img src="/assets/images/upload_image_icon.svg">',
            setupMenu: '<img src="/assets/images/menu_icon.svg">',
            publish: '<img src="/assets/images/publish_icon.svg">',
            epos: '<img src="/assets/images/epos.svg">',
            gratitude: '<img src="/assets/images/gratitude_icon.svg">',
            unibill: '<img src="/assets/images/unibillIcon.svg">',
            menu: '<img src="/assets/images/menuIcon.svg">',
            location: '<img src="/assets/images/locationIcon.svg">'
        });

        this.iconLibraries.registerSvgPack('umami', umamiIconMap);

        this.iconLibraries.registerFontPack('fa', { packClass: 'fa' });
    }

    ngOnInit() {
        if (environment.versionCheckURL) {
            this.versionCheckService.initVersionCheck(environment.versionCheckURL);
        }
        this.analytics.trackPageViews();

        // This can be more simplified with a matcher on info, but then we need mote knowledge about which info each device + browser
        this.analytics.gaEvent(
            'Device',
            'Info',
            `Appversion: ${navigator.appVersion} -- platform: ${navigator.platform}`
        );

        //this.setBodyStylesOnLessThanMdDevices();
    }

    public ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private setBodyStylesOnLessThanMdDevices() {
        const { md } = this.breakpointService.getBreakpointsMap();
        this.themeService
            .onMediaQueryChange()
            .pipe(
                map(([, currentBreakpoint]) => currentBreakpoint.width < md),
                takeUntil(this.destroy$)
            )
            .subscribe((isLessThanMd: boolean) => {
                // Adding property to document when we scroll
                // We do this to prevent jumping to top of page when we close the modal on mobiles.
                window.addEventListener('scroll', () => {
                    document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
                });
                // Adding styling to body when dialog opens
                if (isLessThanMd) {
                    this.matDialog.afterOpened.pipe(takeUntil(this.isViewportBiggerOrEqualToMd$)).subscribe(res => {
                        const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
                        const body = document.body;
                        body.style.position = 'fixed';
                        body.style.overflow = 'hidden';
                        body.style.top = `-${scrollY}`;
                    });
                } else {
                    this.isViewportBiggerOrEqualToMd$.next();
                }

                // Removing styling added when modal opens
                this.matDialog.afterAllClosed.subscribe(res => {
                    const body = document.body;
                    const scrollY = body.style.top;
                    body.style.position = 'static';
                    body.style.top = '';
                    body.style.overflow = 'auto';
                    window.scrollTo(0, parseInt(scrollY || '0') * -1);
                });
            });
    }
}
